import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { themeFontWeights } from "@dana/MobiusOverrides/styles/variables";
import { cartLinkStyles } from "@dana/Overrides/Widgets/Common/CartLink";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import Color from "color";
import { css } from "styled-components";

cartLinkStyles.cartWrapper = mergeToNew(cartLinkStyles.cartWrapper, {
    css: css`
        &.not-authenticated-cart {
            pointer-events: none;
            cursor: not-allowed;
        }

        &:hover {
            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaBrightBlue};
                    }
                }
            }

            .desktop-cart-count {
                background: ${themeColors.secondary.danaBrightBlue};
                color: ${themeColors.primary.richBlack};
            }
        }
    `,
});

cartLinkStyles.routerLink = mergeToNew(cartLinkStyles.routerLink, {
    css: css`
        height: auto;
        > ${StyledTypography} {
            text-decoration: none;
        }

        &:hover {
            text-decoration: none;
        }

        &:focus,
        &:focus-visible {
            outline: none;
            border: 1px solid ${themeColors.primary.white};
            box-shadow: 0px 0px 0px 1px ${themeColors.secondary.danaDarkBlue};
            text-decoration: none;
            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeColors.secondary.danaBrightBlue};
                    }
                }
            }

            .desktop-cart-count {
                background: ${themeColors.secondary.danaBrightBlue};
                color: ${themeColors.primary.richBlack};
            }
        }
    `,
});

cartLinkStyles.cartCountWrapper = mergeToNew(cartLinkStyles.cartCountWrapper, {
    css: css`
        display: flex;
        align-items: center;
        column-gap: 8px;
    `,
});

cartLinkStyles.desktopCartCount = mergeToNew(cartLinkStyles.desktopCartCount, {
    color: themeColors.primary.white,
    size: 14,
    lineHeight: "10px",
    weight: themeFontWeights.semiBold,
    css: css`
        display: flex;
        padding: 5px;
        background: ${themeBackgrounds.darkGray};
        border-radius: 2px;
        min-width: 28px;
        justify-content: center;
    `,
});

cartLinkStyles.desktopCartPrice = mergeToNew(cartLinkStyles.desktopCartPrice, {
    css: css`
        display: none;
    `,
});

cartLinkStyles.authorizedCartCount = mergeToNew(cartLinkStyles.authorizedCartCount, {
    color: themeColors.primary.richBlack,
    size: 14,
    lineHeight: "10px",
    weight: themeFontWeights.semiBold,
    css: css`
        display: flex;
        padding: 5px;
        background: ${themeColors.secondary.danaBrightBlue};
        border-radius: 2px;
        min-width: 28px;
        justify-content: center;
    `,
});
